/** Theme tokens — light is the house taupe/gold identity, dark is its evening twin.
 * Choice: "light" | "dark" | "system". Applied as html[data-theme="light|dark"]. */
const KEY = "inndulge_theme";
let currentChoice = "system";

export const getStoredTheme = () => {
  try { return localStorage.getItem(KEY) || "system"; } catch { return "system"; }
};

export const setStoredTheme = (t) => {
  try { localStorage.setItem(KEY, t); } catch { /* private mode */ }
};

export const resolveTheme = (choice) => {
  if (choice === "light" || choice === "dark") return choice;
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

export const applyTheme = (choice) => {
  currentChoice = choice || "system";
  document.documentElement.setAttribute("data-theme", resolveTheme(currentChoice));
};

// Follow the OS while the choice is "system"
if (typeof window !== "undefined" && window.matchMedia) {
  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
    if (currentChoice === "system") applyTheme("system");
  });
}
